import CutwiseAPIClient, { METHOD_GET, METHOD_POST } from '@/common/network/CutwiseAPIClient';
import QueryResult from '@/common/network/QueryResult';
import ToFormDataSerializationStrategy from '@/common/network/serialization/ToFormDataSerializationStrategy';
import { ServiceType } from '@/conversion/constants/serviceType';
import { CreateOrderResponse } from '@/conversion/types/CreateOrderResponse';
import { GetFreeTierResponse } from '@/conversion/types/GetFreeTierResponse';

import { ServiceOrderModel } from '../entities/ServiceOrder';

export const PATH_ORDER_LIST = 'api/order/list';
export const PATH_CREATE_ORDER = 'api/order/conversion';
export const PATH_MODELS_FREETIER = 'api/models/freetier';

interface CreateOrderRequest {
  service: ServiceType;
  file1: File;
}

export type { CreateOrderRequest };
export default class ServicesAPI {
  getOrderList(): Promise<QueryResult<ServiceOrderModel[]>> {
    const qb = CutwiseAPIClient.createQueryBuilder().method(METHOD_GET).path(PATH_ORDER_LIST);

    const query = qb.getQuery();

    return CutwiseAPIClient.sendQuery(query);
  }

  createOrder(data: CreateOrderRequest): Promise<QueryResult<CreateOrderResponse>> {
    const qb = CutwiseAPIClient.createQueryBuilder()
      .method(METHOD_POST)
      .path(PATH_CREATE_ORDER)
      .body(data)
      .serializer(ToFormDataSerializationStrategy)
      .suppressErrorNotifications();

    const query = qb.getQuery();

    return CutwiseAPIClient.sendQuery(query);
  }

  getFreeTierState(): Promise<QueryResult<GetFreeTierResponse>> {
    const qb = CutwiseAPIClient.createQueryBuilder().method(METHOD_GET).path(PATH_MODELS_FREETIER);

    const query = qb.getQuery();

    return CutwiseAPIClient.sendQuery(query);
  }
}
